import { forwardRef } from 'react'

import type { InputProps } from './Input'
import Input from './Input'

const InputPerFlag = forwardRef<HTMLInputElement, InputProps>(
  (props: InputProps, ref) => {
    return <Input {...props} ref={ref} />
  }
)

export type { InputProps }

export default InputPerFlag
